module.exports = __webpack_public_path__ + "static/media/instrument.bcfb66d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instrument.svg
// module id = 183
// module chunks = 0